import { decode } from 'html-entities';
import { trackByKey } from '../../tracking/tracking';
import { logger } from '@tuic/logger';

export const createOnClickHandler = () => {
  return (event: MouseEvent | TouchEvent) => {
    const element = (event.target as HTMLElement) || null;
    const trackingContext = (element && element.dataset.trackOnClick) || false;

    // logger.debug('Tealium', event, element, trackingContext);

    // Incoming context format e.g. 'foo.bar=a:a|b:b'
    if (!trackingContext) {
      return;
    }

    // Split context into key and props
    const data = trackingContext.split('=');
    let trackingKey = data[0] || 'null'; // e.g. 'foo.bar'
    let trackingProps = data[1] || null; // e.g. 'a:a|b:b'
    let propsObject = {};

    // v2 becomes more dynamic
    // const elementText = element.textContent || element.innerText || null;
    // const tagName = element.tagName || null;

    if (trackingProps) {
      // Strip HTML tags first
      trackingProps = trackingProps.replace(/<[^>]*>?/gm, '');

      // Decode HTML entities to characters e.g. &reg; to ®
      trackingProps = decode(trackingProps);

      // Convert 'a:a|b:b' to {a: 'a', b: 'b'}
      propsObject = Object.fromEntries(
        trackingProps.split('|').map(i => i.split(':')),
      );
    }

    // logger.debug('Tealium', element, trackingKey, propsObject);

    if (trackByKey[trackingKey]) {
      trackByKey[trackingKey](propsObject);
    }
  };
};
